import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../context/UserContext';
import './LoginPage.css';

const LoginPage = () => {
  const [userId, setUserId] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const [isAddingNewUser, setIsAddingNewUser] = useState(false);
  const { knownUsers, login } = useUserContext();
  const navigate = useNavigate();
  const hasKnownUsers = knownUsers.length > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextUserId = isAddingNewUser || !hasKnownUsers ? userId.trim() : (selectedUserId || knownUsers[0]);

    if (nextUserId) {
      login(nextUserId);
      navigate('/gallery');
    }
  };

  const handleUseNewUser = () => {
    setIsAddingNewUser(true);
    setUserId('');
  };

  const handleUseExistingUser = () => {
    setIsAddingNewUser(false);
    setUserId('');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="/agora-logo.webp" alt="Agora Education" className="login-logo" />
        <h1>Agora Timeline</h1>
        <form onSubmit={handleSubmit} className="login-form">
          {hasKnownUsers && !isAddingNewUser ? (
            <div className="login-field">
              <label htmlFor="existing-user">Continue as</label>
              <select
                id="existing-user"
                value={selectedUserId || knownUsers[0]}
                onChange={(e) => setSelectedUserId(e.target.value)}
              >
                {knownUsers.map(knownUserId => (
                  <option key={knownUserId} value={knownUserId}>
                    {knownUserId}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div className="login-field">
              <label htmlFor="new-user-id">{hasKnownUsers ? 'New user ID' : 'User ID'}</label>
              <input
                id="new-user-id"
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="Enter a user ID"
                required
                autoFocus={hasKnownUsers}
              />
            </div>
          )}

          <button type="submit">
            {hasKnownUsers && !isAddingNewUser ? 'Continue' : 'Create user'}
          </button>

          {hasKnownUsers && (
            <button
              type="button"
              className="secondary-login-button"
              onClick={isAddingNewUser ? handleUseExistingUser : handleUseNewUser}
            >
              {isAddingNewUser ? 'Use existing user' : 'Use a new user ID'}
            </button>
          )}
        </form>
        <p className="login-note">
          User IDs and timelines are saved only in this browser on this computer.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
